<template>
  <v-row>
    <v-col cols="12" md="4" v-for="news in newsList" class="d-flex">
      <v-hover v-slot:default="{ hover }">
        <v-card
          :elevation="hover ? 12 : 2"
          class="mx-auto flex-grow-1"
          outlined
          :to="{ name: 'article', params: { id: news.id }}"
        >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">{{ $t(`common.${news.data.type}`) }}</div>
              <v-list-item-title class="headline mb-1">
                <v-img
                  :src="'https://res.cloudinary.com/twodm/image/fetch/' + news.data.cover.url"
                  lazy-src="https://picsum.photos/id/11/10/6"
                  height="200px"
                >
                </v-img></v-list-item-title>
              <v-list-item-subtitle class="title">{{ news.data.title[0].text }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <v-spacer />
            <v-btn text>{{ $t('common.read-more') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'NewsGrid',
  props: {
    newsList: Array,
  },
};
</script>

<style scoped>

</style>
